import styled from 'styled-components/macro';
import * as colors from 'components/common/colorConstants';

export const Root = styled.div`
  padding: 32px;
  border-bottom: 6px solid ${colors.lightGray14};
  font-weight: 500;
  text-align: center;
`;

export const IconWrapper = styled.div`
  color: ${colors.intentValidation.red1};
  & svg {
    display: block;
    margin: 0 auto;
  }
`;

export const Title = styled.h3`
  margin: 8px 0 0;
  font-size: 14px;
  line-height: 18px;
  color: ${colors.black4};
`;

export const Text = styled.p`
  margin: 0;
  font-size: 11px;
  line-height: 18px;
  color: ${colors.darkGray1};
`;
